<template>
  <li :class="group_item_class">
    <a href="javascript:" class="sidebar-menu__item-link" @click="open">
      <template v-if="item.icon">
        <div :is="item.icon" :key="`${item.name}-${item.route}`" class="sidebar-menu__item-icon" />
      </template>
      {{ $t(item.title) }}
    </a>
    <slide-up-down :active="is_open" :duration="300">
      <ul class="sidebar-menu__item__child">
        <template v-for="(sub_item, index) in item.children">
          <template v-if="sub_item.is_external">
            <nav-pure-link :key="index" :href="sub_item.route">
              {{ $t(sub_item.title) }}
            </nav-pure-link>
          </template>
          <template v-else>
            <sub-item :key="index" :to="sub_item.route" :routes="sub_item.routes">
              {{ $t(sub_item.title) }}
            </sub-item>
          </template>
        </template>
      </ul>
    </slide-up-down>
  </li>
</template>

<script>
  import SlideUpDown from 'vue-slide-up-down';
  import SubItem from './nav-sub-item';
  import NavPureLink from '@shared/components/layout-default/layout-default-nav/nav-pure-link';
  export default {
    components: { NavPureLink, SlideUpDown, SubItem },
    props: {
      item: {
        type: Object,
        default: function() {
          return {
            name: '',
            title: '',
            route: '',
            children: []
          };
        }
      },
      is_opened: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      is_open() {
        const current_path = `/${this.item.name}`;
        const is_active = this.$route.matched.some(m => {
          return m.regex.test(current_path);
        });
        return is_active || this.is_opened;
      },
      group_item_class() {
        return {
          'sidebar-menu__item': true,
          'sidebar-menu__item--sub': true,
          'sidebar-menu__item--active': this.is_open
        };
      }
    },
    methods: {
      open() {
        this.$emit('open', this.item.name);
      }
    }
  };
</script>
